import { calculateDateDifference } from './date';
import { Pqr } from '../../shared/types/modules/pqr';
import { Alerts } from '../../shared/types/legalProceedings/alerts';

const RED = '#fb0301';
const GREEN = '#92d050';
const DARK_GREEN = '#3c7d22';

const getAlertColor = (daysDifference: number, alertDays: number): string => {
    if (daysDifference <= 0) return RED;
    if (daysDifference <= Number(alertDays)) return GREEN;
    return DARK_GREEN;
};

export const processAlert = (alert: Alerts, row: Pqr) => {
    let colorFuragDate = '';
    let colorSacDate = '';

    if (typeof alert.alertSection.alertDate === 'object') {
        const { alertDate, classification, numberDays } = alert.alertSection;

        const isCalendarDays =
            classification === 'ALERTS_CLASSIFICATION_CALENDAR_DAYS';
        const currentDate = new Date();

        if (
            alertDate.code === 'ALERTS_ALERT_DATE_SAC_DATE' &&
            row.statusManagement?.sacDate
        ) {
            const sacDate = new Date(row.statusManagement.sacDate);
            const daysDifference = calculateDateDifference(
                currentDate,
                sacDate,
                isCalendarDays
            );
            colorSacDate = getAlertColor(daysDifference, Number(numberDays));
            if (row.statusManagement?.furagDate) {
                const furagDate = new Date(row.statusManagement.furagDate);
                if (colorSacDate === RED) {
                    colorFuragDate = GREEN;
                } else if (colorSacDate === DARK_GREEN) {
                    colorFuragDate = DARK_GREEN;
                }
                if (furagDate <= currentDate) {
                    colorFuragDate = RED;
                }
            }
        } else if (
            alertDate.code === 'ALERTS_ALERT_DATE_FURAG_DATE' &&
            row.statusManagement?.furagDate
        ) {
            const furagDate = new Date(row.statusManagement.furagDate);
            const daysDifference = calculateDateDifference(
                currentDate,
                furagDate,
                isCalendarDays
            );
            colorFuragDate = getAlertColor(daysDifference, Number(numberDays));
        }
    }

    return { colorSacDate: colorSacDate, colorFuragDate: colorFuragDate };
};
